import { css, cx } from '@fable/theme'

interface Props {
  color: string
}

export const FlowerSleepyZ = ({ color }: Props) => {
  return (
    <svg
      className={cx(
        'anim__flower-sleepy-z',
        css`
          width: 9px;
          position: absolute;
          right: 0;
          top: 70%;
          transform: translateY(-50%) scale(0);
          z-index: 1;
          will-change: transform;
        `
      )}
      width="11"
      height="13"
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.49733 12.2692C0.50348 12.1815 0.0357873 11.3338 0.50348 10.4277C0.91271 9.75538 2.66656 8.00154 6.46656 4.20154C7.34348 3.32461 6.40809 3.14923 4.94656 3.38308C3.63117 3.55846 2.46194 3.55846 2.54963 2.38923C2.60809 1.92154 2.84194 1.6 3.2804 1.48308C3.80656 1.27846 8.42502 0.664615 9.30194 0.664615C10.4419 0.752307 10.9681 1.65846 10.5004 2.74C9.91579 4.02615 5.1804 8.49846 5.03425 8.76154C4.30348 9.75538 5.58963 9.60923 6.99271 9.25846C8.6004 8.93692 9.38963 9.25846 9.4481 10.1646C9.47733 10.7785 9.15579 11.1292 8.42502 11.2462C2.25733 12.2985 2.11117 12.3277 1.49733 12.2692Z"
        fill={color}
      />
    </svg>
  )
}
